/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import connect from "react-redux/es/connect/connect"
import {withRouter} from "react-router"
import {bindActionCreators} from "redux"
import {Button, Card, Grid, Pagination} from '@scuf/common'
import * as LearningLoopActions from "./LearningLoopActions"
import * as AppConfigActions from '../appConfig/AppConfigActions'
import {DataTable} from '@scuf/datatable'
import Loader from '../../common/Loader'
import CheckboxDropdown from '../../common/CheckboxDropdown'
import SubmitPasswordModal from '../../common/SubmitPasswordModal'
import {ACTION_TYPES} from "./LearningLoopConst";
import {showNotification} from "../../common/ToastNotification";
import {formatDateTime} from "../../common/LocaleHelper";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {fetchLdiNamesAndIds} from "../../api/AppConfigs";
import LdiSelector from "../../common/LdiSelector"

class LearningLoop extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            ldiNamesAndIds: null,
            selectedLdiForHDR: -1,
            modalWindow: false,
        }

        this.filterExportedStatesChanged = this.filterExportedStatesChanged.bind(this)
        this.exportLearningLoopPacket = this.exportLearningLoopPacket.bind(this)
        this.closePasswordModal = this.closePasswordModal.bind(this)
        this.submitPassword = this.submitPassword.bind(this)
        this.getActionFilter = this.getActionFilter.bind(this)
        this.refreshTable = this.refreshTable.bind(this)
        this.filterPaginationChanged = this.filterPaginationChanged.bind(this)
        this.fetchLdiNamesAndIds = this.fetchLdiNamesAndIds.bind(this)
        this.countNotExportedLearningLoopPackets = this.countNotExportedLearningLoopPackets.bind(this)
        this.fetchLearningLoopPackets = this.fetchLearningLoopPackets.bind(this)
    }

    componentDidMount() {
        this.fetchLdiNamesAndIds()
    }

    countNotExportedLearningLoopPackets() {
        this.props.LearningLoopActions.countNotExportedLearningLoopPackets(this.state.selectedLdiForHDR)
    }

    fetchLearningLoopPackets(newFilter) {
        const {filter} = this.props
        this.props.LearningLoopActions.fetchLearningLoopPackets(this.state.selectedLdiForHDR, newFilter != null ? newFilter : filter)
    }

    fetchLdiNamesAndIds() {
        const me = this
        fetchLdiNamesAndIds().then(function (response) {
            if (response.length === 1) {
                me.setState({ldiNamesAndIds: response, selectedLdiForHDR: response[0].value}, () => {
                    me.countNotExportedLearningLoopPackets()
                    me.fetchLearningLoopPackets()
                    me.props.AppConfigActions.fetchAppConfigs(me.state.selectedLdiForHDR).catch(err => {
                        showNotification({
                            translationPropertyKey: err,
                            severity: "critical",
                        });
                    })
                    me.props.AppConfigActions.testKmsConnection(me.state.selectedLdiForHDR)
                })
            } else {
                me.setState({ldiNamesAndIds: response})
            }
        });
    }

    filterExportedStatesChanged(selectedStates) {
        const filter = {
            ...this.props.filter,
            exportedStates: selectedStates,
            start: 1,
        }

        this.props.LearningLoopActions.filterChanged(filter)
        this.countNotExportedLearningLoopPackets();
        this.fetchLearningLoopPackets(filter)
    }

    filterPaginationChanged(page, itemsPerPage) {
        const filter = {
            ...this.props.filter,
            start: page,
            limit: itemsPerPage,
        }

        this.props.LearningLoopActions.filterChanged(filter)
        this.countNotExportedLearningLoopPackets()
        this.fetchLearningLoopPackets(filter)
    }

    exportLearningLoopPacket() {
        const {intl, kmsConnection} = this.props

        if(kmsConnection.success === false) {
            this.setState({modalWindow: true})
            return
        }

        this.props.LearningLoopActions.exportLearningLoopPacket(this.state.selectedLdiForHDR).then((response) => {
            this.fetchLearningLoopPackets()
            if (response) {
                showNotification({
                    translationPropertyKey: 'learningLoop.action.EXPORTED.success',
                    severity: "success",
                });
            } else {
                showNotification({
                    translationPropertyKey: 'learningLoop.action.EXPORTED.failure',
                    severity: "critical",
                })
            }

        }).catch((err) => {
            if(err && err.showErrorNotification === true) {
                showNotification({
                    translationPropertyKey: err.errorKey,
                    severity: "critical",
                });
            }
        })
    }

    closePasswordModal() {
        this.setState({modalWindow: false})
    }

    submitPassword(componentState) {
        const {intl} = this.props
        this.props.AppConfigActions.submitPassword(this.state.selectedLdiForHDR, componentState.password).then(() => {
            showNotification({
                translationPropertyKey: 'admin.password.modal.success',
                severity: "success",
            })
            this.exportLearningLoopPacket()
            this.setState({modalWindow: false})
            this.props.AppConfigActions.testKmsConnection(this.state.selectedLdiForHDR)
        }).catch((err) => {
            if (err && err.generalError === true) {
                showNotification({
                    translationPropertyKey: err.errorKey,
                    severity: "critical",
                });
            }
        });
    }

    getActionFilter() {
        const {intl} = this.props
        return Object.keys(ACTION_TYPES).map(key => {
            return {
                key: ACTION_TYPES[key],
                text: intl.formatMessage({id: 'learningLoop.action.' + ACTION_TYPES[key]}),
            }
        });
    }

    refreshTable() {
        this.countNotExportedLearningLoopPackets();
        this.fetchLearningLoopPackets()
    }

    isReadOnly() {
        return !userHasActivity(this.props.userProfile, ACTIVITY_TYPES.CONFIG_WRITE)
    }

    render() {
        const {intl, learningLoopData, loading, kmsConnection, filter, notExportedPacketsCount} = this.props

        const data = this.translateLLData(learningLoopData.results, intl)
        let paginator = null
        if (learningLoopData.totalCount > filter.limit) {
            paginator =
                <Pagination
                    totalItems={learningLoopData.totalCount}
                    itemsPerPage={filter.limit}
                    showDisplayDetails
                    boundaryRange={5}
                    onPageChange={this.filterPaginationChanged}
                    activePage={filter.start}
                />
        }

        let ldiSelector = null
        if (this.state.ldiNamesAndIds != null && this.state.ldiNamesAndIds.length > 1) {
            ldiSelector =
                <LdiSelector
                    ldiNamesAndIds={this.state.ldiNamesAndIds}
                    selectedLdiForHDR={this.state.selectedLdiForHDR}
                    onLdiChange={(ldiData) => {
                        this.setState({
                            selectedLdiForHDR: ldiData,
                            selectedVariants: new Map(),
                        }, () => {
                            this.countNotExportedLearningLoopPackets();
                            this.fetchLearningLoopPackets();
                            this.props.AppConfigActions.fetchAppConfigs(this.state.selectedLdiForHDR).catch(err => {
                                showNotification({
                                    translationPropertyKey: err,
                                    severity: "critical",
                                });
                            })
                            this.props.AppConfigActions.testKmsConnection(this.state.selectedLdiForHDR)
                        });
                    }}
                    getErrorMessage={() => {
                    }}
                />
        }

        return (
            <React.Fragment>
                {this.state.ldiNamesAndIds != null && this.state.ldiNamesAndIds.length > 1 ?
                    <Card>
                        <Card.Header title={intl.formatMessage({id: "multipleLdis.selection.header"})}/>
                        <Card.Content>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={4} sWidth={12}>
                                        <div className="ldiSelector">
                                            {ldiSelector}
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Card.Content>
                    </Card>
                    :
                    null
                }

                {this.state.selectedLdiForHDR !== -1 ?
                    <Card id="learning-loop">
                        <Loader loading={loading}/>
                        <SubmitPasswordModal open={this.state.modalWindow} onClose={this.closePasswordModal} onSubmit={this.submitPassword} connectorMessage={kmsConnection.connectionError} loading={kmsConnection.loading}/>
                        <Card.Content>
                            <div>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={4} sWidth={12}>
                                            <h3><FormattedMessage id="learningLoop.faults" /></h3>
                                        </Grid.Column>
                                        <Grid.Column width={8} sWidth={12}>
                                            <div className="faults-card-buttons-div">
                                                <Button type="secondary"
                                                        content={intl.formatMessage({id: 'learningLoop.refresh'})}
                                                        onClick={this.refreshTable}
                                                        className="mobile-max-width-button"/>
                                                <Button type="primary"
                                                        content={intl.formatHTMLMessage({id: 'learningLoop.synchronize'})}
                                                        onClick={this.exportLearningLoopPacket}
                                                        className="sync-button mobile-max-width-button"
                                                        disabled={(notExportedPacketsCount <= 0 || this.isReadOnly())}/>
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </div>

                            <CheckboxDropdown className="" label={intl.formatMessage({id: 'learningLoop.faults.show'})}
                                              allOptions={this.getActionFilter()}
                                              onChange={this.filterExportedStatesChanged}
                                              selectedOptions={filter.exportedStates}
                                              initSelectedOptions={filter.exportedStates}/>

                            <div className="datatable-mobile-x-scroll">
                                <DataTable data={data} scrollable={true}>
                                    <DataTable.Column field="name"
                                                      header={intl.formatMessage({id: 'learningLoop.faults.header.name'})}/>
                                    <DataTable.Column field="assetName"
                                                      header={intl.formatMessage({id: 'learningLoop.faults.header.asset'})}/>
                                    <DataTable.Column field="closedDateFormatted"
                                                      header={intl.formatMessage({id: 'learningLoop.faults.header.closed.date'})}/>
                                    <DataTable.Column field="exportDateFormatted"
                                                      header={intl.formatMessage({id: 'learningLoop.faults.header.export.date'})}/>
                                    <DataTable.Column field="syncAttemptDateFormatted"
                                                      header={intl.formatMessage({id: 'learningLoop.faults.header.sync.attempt.date'})}/>
                                    <DataTable.Column field="resultTextTranslated"
                                                      header={intl.formatMessage({id: 'learningLoop.faults.header.failure.reason'})}/>
                                </DataTable>
                                {paginator}
                            </div>

                        </Card.Content>
                    </Card>
                    :
                    null
                }

            </React.Fragment>
        )

    }

    translateLLData(data, intl) {
        const faultConditions = data;

        for (const i in faultConditions) {
            if (faultConditions.hasOwnProperty(i)) {
                const fc = faultConditions[i];
                fc.assetName = fc.asset.name;
                fc.closedDateFormatted = (fc.closed) ? formatDateTime(fc.closed) : ''
                fc.exportDateFormatted = (fc.exportedLL) ? formatDateTime(fc.exportedLL) : ''
                fc.syncAttemptDateFormatted = (fc.syncAttemptDateTime) ? formatDateTime(fc.syncAttemptDateTime) : ''
                fc.resultTextTranslated = (fc.resultText && fc.resultText.length > 0) ? intl.formatMessage({id: fc.resultText}) : ''
            }
        }

        return(faultConditions);
    }
}

const mapStateToProps = (state) => {
    return {
        learningLoopData: state.learningLoopReducer.learningLoopData,
        loading: state.learningLoopReducer.loading,
        filter: state.learningLoopReducer.filter,
        userProfile: state.security.userProfile,
        notExportedPacketsCount: state.learningLoopReducer.notExportedPacketsCount,
        kmsConnection: state.appConfigsReducer.kmsConnection,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        LearningLoopActions: bindActionCreators(LearningLoopActions, dispatch),
        AppConfigActions: bindActionCreators(AppConfigActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(LearningLoop)))